module.exports = __webpack_public_path__ + "static/media/herings_logo.eb0e4c32.svg";